import { cubicBezier } from 'framer-motion';

import AnimationsJS from '@dynatrace/strato-design-tokens/animations-js';

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const openEasing = cubicBezier(
  AnimationsJS.Open.Easing[0],
  AnimationsJS.Open.Easing[1],
  AnimationsJS.Open.Easing[2],
  AnimationsJS.Open.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const closeEasing = cubicBezier(
  AnimationsJS.Close.Easing[0],
  AnimationsJS.Close.Easing[1],
  AnimationsJS.Close.Easing[2],
  AnimationsJS.Close.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const slideInEasing = cubicBezier(
  AnimationsJS.SlideIn.Easing[0],
  AnimationsJS.SlideIn.Easing[1],
  AnimationsJS.SlideIn.Easing[2],
  AnimationsJS.SlideIn.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const slideOutEasing = cubicBezier(
  AnimationsJS.SlideOut.Easing[0],
  AnimationsJS.SlideOut.Easing[1],
  AnimationsJS.SlideOut.Easing[2],
  AnimationsJS.SlideOut.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const fadeInEasing = cubicBezier(
  AnimationsJS.FadeIn.Easing[0],
  AnimationsJS.FadeIn.Easing[1],
  AnimationsJS.FadeIn.Easing[2],
  AnimationsJS.FadeIn.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const fadeOutEasing = cubicBezier(
  AnimationsJS.FadeOut.Easing[0],
  AnimationsJS.FadeOut.Easing[1],
  AnimationsJS.FadeOut.Easing[2],
  AnimationsJS.FadeOut.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const hoverEasing = cubicBezier(
  AnimationsJS.Hover.Easing[0],
  AnimationsJS.Hover.Easing[1],
  AnimationsJS.Hover.Easing[2],
  AnimationsJS.Hover.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const staggeredMotionEasing = cubicBezier(
  AnimationsJS.StaggeredMotion.Easing[0],
  AnimationsJS.StaggeredMotion.Easing[1],
  AnimationsJS.StaggeredMotion.Easing[2],
  AnimationsJS.StaggeredMotion.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const expandCollapseEasing = cubicBezier(
  AnimationsJS.ExpandCollapse.Easing[0],
  AnimationsJS.ExpandCollapse.Easing[1],
  AnimationsJS.ExpandCollapse.Easing[2],
  AnimationsJS.ExpandCollapse.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const moveEasing = cubicBezier(
  AnimationsJS.Move.Easing[0],
  AnimationsJS.Move.Easing[1],
  AnimationsJS.Move.Easing[2],
  AnimationsJS.Move.Easing[3],
);

/**
 * CubicBezier mapping for the design tokens easing
 * @internal
 * */
export const rescaleEasing = cubicBezier(
  AnimationsJS.Rescale.Easing[0],
  AnimationsJS.Rescale.Easing[1],
  AnimationsJS.Rescale.Easing[2],
  AnimationsJS.Rescale.Easing[3],
);
